import { observer } from 'mobx-react';
import { useMemo } from 'react';
import MealChoices from '../../containers/MealChoices/MealChoices';
import mealsStore from '../../store/mealsStore';
import MealActionsPopup from '../MealActionsPopup/MealActionsPopup';
import integrationsStore from 'src/mobx/integrationStore';
import { modalStore } from 'src/mobx/modalStore';
import { IMealGroup } from 'src/types/combo';
import { getTranslate } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  group: IMealGroup;
}

const MealGroup: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const renameGroup = () => {
    if (!props.group.id) return;

    modalStore.openMealGroupEditModal({
      id: props.group.id,
      name: props.group.name,
      onSubmit: mealsStore.renameGroup,
      onDelete: mealsStore.deleteGroup,
    });
  };

  const deleteGroup = () => {
    mealsStore.deleteGroup(props.group.id);
  };

  const checkValid = useMemo((): boolean => {
    return mealsStore.validation.groups.some((group) => group.id === props.group.id && !group.itemsLength);
  }, [props.group]);

  return (
    <li className="meal-group">
      <div className="meal-group__title d-flex flex-row justify-content-start align-items-center">
        <p className="family-semibold text-size-20 color-dark text-elipsis">{getTranslate(props.group.name)}</p>
        <MealActionsPopup
          restrictionPosEdit={integrationsStore.posRestrictions?.comboMealEditItemGroupName}
          restrictionPosDelete={integrationsStore.posRestrictions?.comboMealGroupDelete}
          openEditModal={renameGroup}
          handleDelete={deleteGroup}
        />
      </div>
      <MealChoices group={props.group} />
      {checkValid ? <Text type={TEXT.ERROR} text="at_least_1_item" /> : null}
    </li>
  );
});

export default MealGroup;
